import React from 'react';
import styles from './Footer.module.css';
import { Row, Container, Col } from 'react-bootstrap';
import classnames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

export const Footer: React.FC<{}> = React.memo(() => {
  const { t } = useTranslation();
  return (
    <footer className={classnames(styles.root)}>
      <Container className={styles.footerBlock}>
        <Row className={classnames('d-none', 'd-lg-flex')}>
          <Col xs="6">
            <div className={styles.companyDisclosureLinks}>
              <span><a href={`/privacy-policy`} target="_blank" rel="noopener noreferrer">{t('Privacy Policy')}</a></span>
              <span><a href={`/terms-of-service`} target="_blank" rel="noopener noreferrer">{t('Terms of Service')}</a></span>
              <span><a href={`/license-agreement`} target="_blank" rel="noopener noreferrer">{t('License Agreement')}</a></span>
            </div>
          </Col>
          <Col xs="6" className="text-right">
            <div className={classnames(styles.contactBlock, 'text-center')}>
              <div className={classnames('d-inline', 'p-2')}>
                <FontAwesomeIcon className={styles.icon} icon="phone" />
                <span><a href="tel:1-844-633-8356">1-844-633-8356</a></span>
              </div>
              <div className={classnames('d-inline', 'p-2')}>
                <FontAwesomeIcon className={styles.icon} icon="envelope" />
                <span><a href="mailto:iotcsc@moen.com">iotcsc@moen.com</a></span>
              </div>
            </div>
          </Col>
        </Row>
        <Row className={classnames('d-lg-none')}>
          <Col xs="12" className={classnames('text-center', 'bottom-margin')}>
            <div className={styles.companyDisclosureLinks}>
              <span><a href={`/privacy-policy`} target="_blank" rel="noopener noreferrer">{t('Privacy Policy')}</a></span>
              <span><a href={`/terms-of-service`} target="_blank" rel="noopener noreferrer">{t('Terms of Service')}</a></span>
              <span><a href={`/license-agreement`} target="_blank" rel="noopener noreferrer">{t('License Agreement')}</a></span>
            </div>
          </Col>
          <Col xs="12" className={classnames('text-center')}>
            <div className={classnames(styles.contactBlock, 'text-center')}>
              <div className={classnames('d-inline', 'p-2')}>
                <FontAwesomeIcon className={styles.icon} icon="phone" />
                <span><a href="tel:1-844-633-8356">1-844-633-8356</a></span>
              </div>
              <div className={classnames('d-inline', 'p-2')}>
                <FontAwesomeIcon className={styles.icon} icon="envelope" />
                <span><a href="mailto:iotcsc@moen.com">iotcsc@moen.com</a></span>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
});
